import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-marketing-contacts',
  templateUrl: './marketing-contacts.component.html',
  styleUrls: ['./marketing-contacts.component.scss']
})
export class MarketingContactsComponent implements OnInit {

  ngOnInit(): void {
  } 
 

}
